import React, { useRef, useEffect } from "react";

import loading from "./assets/loading.mp4";

const Loading = () => {
    const videoRef = useRef(null);

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.playbackRate = 2;
        }
    }, []);

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
                width: "100vw",
                backgroundColor: "#000000",
                position: "fixed",
                top: 0,
                left: 0,
                zIndex: 9999,
                margin: 0,
                padding: 0,
            }}
        >
            {/* Small container for the video */}
            <div style={{ width: "150px", height: "150px" }}>
                <video
                    ref={videoRef}
                    src={loading}
                    autoPlay
                    loop
                    muted
                    playsInline
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        display: "block",
                    }}
                />
            </div>
        </div>
    );
};

export default Loading;
